import { Bus } from '../../domain/types'

export function getBusNumber(bus?: Bus): string {
  if (!bus)
    return 'XX'

  const { segmentS1, segmentS2, direction } = bus

  if (direction === 'Inbound') {
    return segmentS1 || 'XX'
  }

  if (!segmentS1)
    return segmentS2 || 'XX'

  const hasLetters = /[A-Z]/i.test(segmentS1)
  return hasLetters ? segmentS2 || segmentS1 : segmentS1
}
